import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Papa from 'papaparse';
import { BASE_URL } from '../../components/CommonExport.js';
import { DataGrid } from '@mui/x-data-grid';
import { TextField, Box, Typography, Paper, CircularProgress, Alert, IconButton, Grid, Button } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Link } from 'react-router-dom';
import Component from '../../components/Component.js';

const DailyDashboard = () => {
    const [dailyEngagementData, setDailyEngagementData] = useState([]);
    const [monthlyEngagementData, setMonthlyEngagementData] = useState({});
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [month, setMonth] = useState(() => {
        const now = new Date();
        return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
    });

    console.log(month);

    useEffect(() => {
        if (!month) return; // Avoid fetching data before month is selected

        const fetchUsers = async () => {
            setLoading(true);
            setError(null);

            try {
                const response = await axios.get(`${BASE_URL}/tracking/daily-engagement?month=${month}`);
                const dailyEngagement = response.data.data.result.dailyEngagement.map((item) => ({
                    ...item,
                    entry_date: new Date(item.entry_date).toLocaleDateString('en-GB'), // Format date to DD/MM/YYYY
                    total_installs: Number(item.total_views) + Number(item.total_posts) + Number(item.total_likes) + Number(item.total_unique_likes) + Number(item.total_comments) + Number(item.total_unique_comments) + Number(item.total_followers),
                }));
                const monthlyEngagement = response.data.data.result.monthlyEngagement
                console.log(monthlyEngagement);
                console.log(dailyEngagement);
                setMonthlyEngagementData(monthlyEngagement);
                setDailyEngagementData(dailyEngagement);
            } catch (err) {
                setError(err.response?.data?.message || 'Failed to fetch data');
            } finally {
                setLoading(false);
            }
        };

        fetchUsers();
    }, [month]);

    const handleMonthChange = (event) => {
        console.log(event.target.value)
        setMonth(event.target.value);
    };

    const columns = [
        {field: 'entry_date', headerName: 'Date', width: 200, },
        {field: 'posts', headerName: 'Posts', width: 200, },
        {field: 'unique_views', headerName: 'Unique Views', width: 200, },
        {field: 'total_views', headerName: 'Total Views', width: 200, },
        {field: 'ratings', headerName: 'Ratings', width: 200, },
        {field: 'followers', headerName: 'Followers', width: 200, },
        {field: 'total_likes', headerName: 'Total Likes', width: 200, },
        {field: 'unique_likes', headerName: 'Unique Likes', width: 200, },
        {field: 'total_comments', headerName: 'Comments', width: 200, },
        {field: 'unique_comments_received', headerName: 'Unique Comments', width: 200, },
        {field: 'total_shares', headerName: 'Total Shares', width: 200, },
        {field: 'unique_shares', headerName: 'Unique Shares', width: 200, },
        {field: 'unique_creators', headerName: 'Unique Creators', width: 200, },
        {field: 'average_engagement_per_post', headerName: 'Average Engagement Per Post', width: 200, },
        {field: 'custom_engagement_score', headerName: 'Engagement Score', width: 200, },
        {field: 'daily_pool', headerName: 'Daily Pool Engagement', width: 200, },
    ];
    const calculateTotals = (data) => {
        return {
          totalViews: data.reduce((acc, row) => acc + Number(row.total_views || 0), 0),
          totalPosts: data.reduce((acc, row) => acc + Number(row.posts || 0), 0),
          totalRatings: data.reduce((acc, row) => acc + Number(row.ratings || 0), 0),
          totalLikes: data.reduce((acc, row) => acc + Number(row.total_likes || 0), 0),
          totalComments: data.reduce((acc, row) => acc + Number(row.total_comments || 0), 0),
          totalFollowers: data.reduce((acc, row) => acc + Number(row.followers || 0), 0),
          totalShares: data.reduce((acc, row) => acc + Number(row.total_shares || 0), 0),
          totalUniqueViews: monthlyEngagementData.unique_views,
          totalUniqueLikes: monthlyEngagementData.unique_likes,
          totalUniqueComments: monthlyEngagementData.unique_comments,
          totalUniqueShares: monthlyEngagementData.unique_shares
        };
      };
    const totals = calculateTotals(dailyEngagementData);

    const exportToCSV = () => {
        const csvData = dailyEngagementData.map((item) => ({
            Date: item.entry_date,
            Posts: item.posts,
            'Unique Views': item.unique_views,
            'Total Views': item.total_views,
            Ratings: item.ratings,
            Followers: item.followers,
            'Total Likes': item.total_likes,
            'Unique Likes': item.unique_likes,
            Comments: item.total_comments,
            'Unique Comments': item.unique_comments_received,
            'Total Shares': item.total_shares,
            'Unique Shares': item.unique_shares,
            'Unique Creators': item.unique_creators,
            'Average Engagement Per Post': item.average_engagement_per_post,
            'Engagement Score': item.custom_engagement_score,
            'Daily Pool Engagement': item.daily_pool,
        }));
        const csv = Papa.unparse(csvData);
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', `daily_dashboard_${month}.csv`);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <Component>
        <div className="page-body">
          <div className="container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <div className="d-flex align-items-center">
                    <IconButton style={{ background: '#FFFFFF' }} component={Link} to="/">
                      <ArrowBackIcon />
                    </IconButton>
                    <h3 style={{ marginLeft: '20px' }}>Daily Dashboard</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
  
          <div className="container-fluid">
            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="card-body">
        <Paper elevation={3} style={{ padding: '20px' }}>

            <Box mb={3} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 2, flexWrap: 'wrap' }}>
                <Box style={{ maxWidth: '300px', width: '100%' }}>
                    <TextField
                        label="Select Month"
                        type="month"
                        variant="outlined"
                        fullWidth
                        value={month}
                        onChange={handleMonthChange}
                        helperText="Choose a year and month in 'yyyy-mm' format"
                    />
                </Box>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={exportToCSV}
                    disabled={loading || dailyEngagementData.length === 0}
                >
                    Export to CSV
                </Button>
            </Box>
            <Box
                    sx={{
                      backgroundColor: '#f9f9f9',
                      border: '1px solid #ddd',
                      padding: '16px',
                      borderRadius: '8px',
                      marginBottom: '20px'
                    }}
                  >
                    <Grid container spacing={2}>
                      <Grid item xs={6} sm={4}><Typography>Total Views: {totals.totalViews}</Typography></Grid>
                      <Grid item xs={6} sm={4}><Typography>Total Posts: {totals.totalPosts}</Typography></Grid>
                      <Grid item xs={6} sm={4}><Typography>Total Ratings: {totals.totalRatings}</Typography></Grid>
                      <Grid item xs={6} sm={4}><Typography>Total Likes: {totals.totalLikes}</Typography></Grid>
                      <Grid item xs={6} sm={4}><Typography>Total Comments: {totals.totalComments}</Typography></Grid>
                      <Grid item xs={6} sm={4}><Typography>Total Followers: {totals.totalFollowers}</Typography></Grid>
                      <Grid item xs={6} sm={4}><Typography>Total Shares: {totals.totalShares}</Typography></Grid>
                      <Grid item xs={6} sm={4}><Typography>Total Unique Views: {totals.totalUniqueViews}</Typography></Grid>
                      <Grid item xs={6} sm={4}><Typography>Total Unique Likes: {totals.totalUniqueLikes}</Typography></Grid>
                      <Grid item xs={6} sm={4}><Typography>Total Unique Comments: {totals.totalUniqueComments}</Typography></Grid>
                      <Grid item xs={6} sm={4}><Typography>Total Unique Shares: {totals.totalUniqueShares}</Typography></Grid>
                    </Grid>
                  </Box>


            {loading ? (
                <Box display="flex" justifyContent="center" mt={3}>
                    <CircularProgress />
                </Box>
            ) : error ? (
                <Alert severity="error" mt={3}>
                    {error}
                </Alert>
            ) : (
                <Box mt={3} style={{ height: 400 }}>
                    <DataGrid
                        rows={dailyEngagementData}
                        columns={columns}
                        pageSize={5}
                        rowsPerPageOptions={[5]}
                        disableSelectionOnClick
                        getRowId={(row) => row.entry_date} // Use a unique field as the row ID
                    />
                </Box>
            )}
        </Paper>
        </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Component>
    );
};

export default DailyDashboard;
